import { Component, OnInit ,ViewChild} from '@angular/core';
import { ViewWillEnter,IonPopover } from '@ionic/angular';
import { Router, ActivatedRoute } from '@angular/router';
import { GtrakAuthService } from '../../../authentication/services/gtrak-auth.service';
import { AccountManagementService } from '../../services/account-management.service';
import { ToasterService } from '../../../../common/services/toaster.service';


@Component({
  selector: 'app-manage-department-page',
  templateUrl: 'manage-department.page.html',
  styleUrls: [
    './manage-department.page.scss',
    '../../styles/account-management.styles.scss',
  ],
})
export class ManageDepartmentPage implements OnInit, ViewWillEnter {
  @ViewChild('deptPopover') deptPopover!: IonPopover;
  loaded:boolean=false;
  currentRoute:string;
  login:string;
  id!: string;
  isCC = false;
  deptList:any;
  newCustomer = '';
  assignedDepts:any;
  result:any;
  customerName:string;
  isDeptModalOpen = false;
  deptSearch = '';
  filteredDepartments: any[] = [];
  currentCustomer: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: GtrakAuthService,
    private accountService: AccountManagementService,
    private toasterService: ToasterService
  ) {
    this.currentRoute = null;
  }

  async ngOnInit(): Promise<void> {
    this.loaded=false;
    
    if (!this.authService.user.canViewAccountManagement) {
      this.router.navigate([this.authService.user.homeLocation]);
    }
     this.login = this.route.snapshot.params.login;
    this.currentRoute = this.router.url;
    this.customerName=localStorage.getItem('customerName');
    await this.loadData();
    this.loaded=true;
  }

  async ionViewWillEnter() {
  
   
  }
   async loadData(){
    this.loaded=false;
     this.result= await this.accountService.GetAssignedDepartment(this.login);
     this.assignedDepts=this.result?.assignedDepts;
     this.deptList=this.result?.deptList;
     this.loaded=true;
  }
  
filterDepartments(cust: any) {
  const search = (this.deptSearch || '').toLowerCase();

  if (!search) {
    // 🔥 Show ALL records by default
    this.filteredDepartments = [...cust.departmentList];
    return;
  }

  this.filteredDepartments = cust.departmentList.filter((d: any) =>
    d.departmentCode.toLowerCase().includes(search) ||
    d.departmentName.toLowerCase().includes(search)
  );
}
async openDropdown(ev: Event, cust: any) {
  this.deptSearch = '';
  this.filteredDepartments = [...cust.departmentList];


}

async selectDepartment(cust: any, dept: any) {
  cust.selectedDept = dept.departmentCode;
  cust.selectedDeptLabel =
    `(${dept.departmentCode}) ${dept.departmentName}`;
     await this.deptPopover.dismiss();
}
   async addCustomer() {
    if(this.newCustomer!=null && this.newCustomer!=""){
     this.result= await this.accountService.AddCustomerForUser(this.newCustomer,this.login);
     if(this.result=="Success"){
      this.loadData();
      this.newCustomer="";
       this.toasterService.presentToast(
        'primary',
        '',
        "Successfully Customer Added",
        1000
      );
    }
    else{
       this.toasterService.presentToast(
        'danger',
        '',
        this.result,
        1000
      );
    }
  }
  else{
    this.toasterService.presentToast(
        'danger',
        '',
       'Please Enter Customer Code.',
        1000
      );
  }
  }

  async removeCustomer(customerCode: string) {
    this.result= await this.accountService.RemoveCustDept(customerCode,"",this.login);
     if(this.result){
      this.loadData();
       this.toasterService.presentToast(
        'primary',
        '',
        "Successfully Customer Removed",
        1000
      );
    }
    else{
       this.toasterService.presentToast(
        'danger',
        '',
        'error',
        1000
      );
    }
  }

  async addDepartment(cust: string,dept:string) {
    
    if(dept!=null){
     this.result= await this.accountService.AddDepartmentForUser(cust,dept,this.login);
     if(this.result=="Success"){
      this.loadData();
       this.toasterService.presentToast(
        'primary',
        '',
        "Successfully Customer Added",
        1000
      );
    }
    else{
       this.toasterService.presentToast(
        'danger',
        '',
        this.result,
        1000
      );
    }
  }
  else{
     this.toasterService.presentToast(
        'danger',
        '',
        'Please select department.',
        1000
      );
  }
  }

 async removeDepartment(customerCode: string, deptCode: string) {
  
    this.result= await this.accountService.RemoveCustDept(customerCode,deptCode,this.login);
      if(this.result){
        this.loadData();
        this.toasterService.presentToast(
          'primary',
          '',
          "Successfully Department Removed",
          1000
        );
      }
      else{
        this.toasterService.presentToast(
          'danger',
          '',
          'error',
          1000
        );
      }
  }

 onEnterKey(event: KeyboardEvent) {
      event.preventDefault();
      event.stopPropagation();
      this.addCustomer();
    }
}